import React, {useEffect, useState, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {Mask} from '@tboerc/maskfy';
import {Spinner} from 'reactstrap';
import {useFormik} from 'formik';
import {isMobile} from 'react-device-detect';

import {areEqual} from '../../../../helpers';
import {api, Context} from '../../../../services';
import Icons from '../../../../assets/svgs/icons';
import {aplicar_taxas, aplicar_taxas_modais, aplicar_taxas_bici_basico, aplicar_taxas_eMoto} from '../../../../helpers/taxas';

const CALLER = 'RESUMO_COBERTURAS';

const INITIAL_VALUES = {
  code: '',
  id_cupom: '',
  tipo_desconto: '',
  valor_desconto: '',
};

let totalAssistencia = 0;

const somarTotalModais = (coberturas, taxas) => {
  const coberturasSelecionadas = coberturas.coberturas;
  let total = 0;

  if (!coberturasSelecionadas.find(({label}) => label === 'assistencia_ciclomotor')) {
    totalAssistencia = 0;
  }

  coberturasSelecionadas.forEach((cob) => {
    total += parseFloat(taxas[cob.label]);
    if (cob.label === 'assistencia_ciclomotor') {
      totalAssistencia = parseFloat(taxas[cob.label]);
    }
  });

  return total;
};

const ResumoCobertura = ({
  position,
  current,
  checkAdvance,
  prevData,
  onSetTotalBike,
  isEdit,
  setIsEdit,
  corPrimaria,
  cnpj_corretor,
}) => {
  const [authState] = useContext(Context);
  const [total, setTotal] = useState(0);
  const [ticket, setTicket] = useState(false);
  const [aplicado, setAplicado] = useState(false);
  const [data, setData] = useState(false);
  const [comTaxa, setComTaxa] = useState(null);
  const sizeRef = useRef();

  useImperativeHandle(ref, () => ({
    values: () => {
      if (prevData.segurado_bicicletas?.length >= 1 || ticket === 'erro') {
        if (prevData.is_campaign === 2 || prevData.is_campaign === 3) {
          return {
            caller: CALLER,
            data: {
              is_campaign: 0,
              cupom: {...values, code: '', id_cupom: '', tipo_desconto: '', valor_desconto: ''},
              total_teste: total,
            },
          };
        } else {
          return {
            caller: CALLER,
            data: {cupom: {...values, code: '', id_cupom: '', tipo_desconto: '', valor_desconto: ''}, total_teste: total},
          };
        }
      } else {
        return {
          caller: CALLER,
          data: {cupom: {...values}, total_teste: total},
        };
      }
    },
    ref: sizeRef,
  }));

  useEffect(() => {
    if (prevData.segurado_bicicletas?.length >= 1 && (ticket !== false || ticket !== 'erro' || ticket !== 'erro_varias_bikes')) {
      setTicket('erro_varias_bikes');
      delete prevData?.cupom;
    } else if (prevData.cupom && !aplicado) {
      if (prevData.cupom.code === 'TOURDEFRANCE') {
        setAplicado(true);
        setComTaxa({codigo: 'TOURDEFRANCE', id_cupom: 178, tipo_desconto: 0, valor_desconto: 10});
        setTicket({codigo: 'TOURDEFRANCE', id_cupom: 178, tipo_desconto: 0, valor_desconto: 10});
        setFieldValue('id_cupom', 178);
        setFieldValue('code', 'TOURDEFRANCE');
        setFieldValue('tipo_desconto', 0);
        setFieldValue('valor_desconto', 10);
      }
    }
  }, [ticket, prevData]);

  const onSubmit = useCallback(
    async (values, actions) => {
      if (prevData.modal === 2) {
        setTicket('erro');
      } else {
        try {
          const {data: resp} = await api.post(
            `cupom/sura_corretor/${3}`,
            {code: values.code, cnpj_corretor},
            {headers: {authorization: authState.token}},
          );

          if (!resp.data) throw new Error();

          actions.setFieldValue('id_cupom', resp.data.id);
          actions.setFieldValue('tipo_desconto', resp.data.tipo_desconto);
          actions.setFieldValue('valor_desconto', resp.data.valor_desconto);
          if (prevData.segurado_bicicletas?.length >= 1) {
            setTicket('erro_varias_bikes');
            delete prevData?.cupom;
          } else {
            setTicket(resp.data);
          }

          actions.setSubmitting(false);
        } catch (e) {
          delete prevData?.cupom;
          setTicket('erro');
          console.log(e);
        }
      }
    },
    [authState.token, prevData.modal],
  );

  const loadData = useCallback(async () => {
    try {
      /*       const valor_mercado = Mask.money.raw(prevData?.segurado_bicicleta?.valor);
      const percentual = prevData.segurado_bicicleta.lmi_contratado / 100; */

      const {data: resp} = await api.post('segurado/sura_corretor/coberturas', {
        valor_mercado: prevData?.segurado_bicicleta?.valor,
        id_modalidade_bicicleta: prevData?.segurado_bicicleta?.id_modalidade_bicicleta,
      });
      if (resp.status !== 200) throw new Error(resp.message);

      setData(resp.data);
    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevData]);

  useEffect(() => {
    if (current === position) {
      loadData();
      checkAdvance({caller: CALLER, status: true});
    }
  }, [checkAdvance, current, loadData, position]);

  useEffect(() => {
    if (data) {
      console.log(prevData.modal === 2);
      if (prevData.modal === 0) {
        setComTaxa(
          aplicar_taxas(data.valor_mercado, data.taxas, prevData.cobertura?.porcentagens, prevData.cobertura?.coberturas),
        );
      } else if (prevData.modal === 2) {
        setComTaxa(
          aplicar_taxas_bici_basico(
            Mask.money.raw(prevData.segurado_bicicleta.valor),
            prevData.segurado_bicicleta?.id_modalidade_bicicleta,
            prevData.cobertura?.porcentagens,
            prevData.cobertura?.coberturas,
            prevData.segurado_bicicleta?.lmi_contratado,
          ),
        );
      } else if (prevData.modal === 3) {
        setComTaxa(
          aplicar_taxas_eMoto(
            Mask.money.raw(prevData.segurado_bicicleta.valor),
            prevData.cobertura?.porcentagens,
            prevData.cobertura?.coberturas,
            prevData.segurado_bicicleta?.lmi_contratado,
          ),
        );
      } else {
        setComTaxa(
          aplicar_taxas_modais(
            prevData.segurado_bicicleta?.id_modalidade_bicicleta,
            Mask.money.raw(prevData.segurado_bicicleta?.valor),
            prevData.cobertura?.porcentagens,
            prevData.cobertura?.coberturas,
          ),
        );
      }
    }
  }, [data, prevData.cobertura, prevData.modal, prevData.segurado_bicicleta]);

  // Buscar resumão na API
  const loadDataResumo = useCallback(async () => {
    try {
      let tempTotal = 0;
      if (prevData.modal === 0 || prevData.modal === 2) {
        let temp = {};
        prevData.cobertura.coberturas.forEach((item, index) => (temp[index] = item));

        const {data: resp} = await api.post('segurado/sura_corretor/resumo', {
          valor_mercado: prevData.segurado_bicicleta.valor,
          id_modalidade_bicicleta: prevData.segurado_bicicleta.id_modalidade_bicicleta,
          coberturas: {...temp, porcentagens: {...prevData.cobertura.porcentagens}},
          lmi_contratado: prevData.segurado_bicicleta.lmi_contratado,
          bici_basico: prevData.modal === 2,
          emoto_sura: prevData.modal === 3,
        });
        setTotal(resp.data.soma);
        tempTotal = resp.data.soma;
      } else {
        const total = somarTotalModais(prevData.cobertura, comTaxa);

        if (prevData.segurado_bicicleta.id_modalidade_bicicleta === 6 && total < 536.9) {
          setTotal(536.9);
          tempTotal = 536.9;
        } else if (prevData.segurado_bicicleta.id_modalidade_bicicleta === 7 && total < 268.45) {
          setTotal(268.45);
          tempTotal = 268.45;
        } else if (
          (prevData.segurado_bicicleta.id_modalidade_bicicleta === 8 ||
            prevData.segurado_bicicleta.id_modalidade_bicicleta === 9) &&
          total < 375.83
        ) {
          setTotal(375.83);
          tempTotal = 375.83;
        } else {
          setTotal(total);
          tempTotal = total;
        }
      }
      setIsEdit(false);
    } catch (e) {
      console.log(e);
    }
  }, [comTaxa, prevData.cobertura, prevData.modal, prevData.segurado_bicicleta]);

  useEffect(() => {
    if (current === position && comTaxa) loadDataResumo();
  }, [current, position, loadDataResumo, comTaxa]);

  const {handleBlur, handleSubmit, values, isSubmitting, setFieldValue} = useFormik({
    initialValues: INITIAL_VALUES,
    onSubmit,
  });

  useEffect(() => {
    onSetTotalBike(total);
  }, [total, isEdit]);

  return (
    <form className="formStep" autoComplete="off" onSubmit={(e) => e.preventDefault()} ref={sizeRef}>
      <div className="controlForms">
        <div className="leftSide">
          <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Coberturas selecionadas</h1>

          <div className="ticketForm">
            <label htmlFor="code" className="codeInputLabel">
              Digite o codigo do cupom
            </label>
            <div className="codeInputDiv">
              <input
                name="code"
                id="code"
                tabIndex={current === position ? 1 : -1}
                onChange={(e) => setFieldValue('code', e.target.value.toUpperCase(), true)}
                onBlur={handleBlur}
                values={values.code}
                className="codeInp"
                placeholder="codigo"
              />
              <button
                type="button"
                tabIndex={-1}
                onClick={handleSubmit}
                style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
                Buscar
              </button>
            </div>

            <div className="controlResponse">
              {isSubmitting ? (
                <div className="loadingDiv">
                  <Spinner color="secondary" />
                </div>
              ) : (
                <div>
                  {!!ticket && (
                    <div>
                      {ticket === 'erro' || ticket === 'erro_varias_bikes' ? (
                        <div className="errorDiv">
                          <p>
                            {prevData.modal === 2
                              ? 'O Bici Sura Essencial não prevê a aplicação de descontos via Cupom.'
                              : ticket === 'erro'
                              ? 'Cupom não encontrado'
                              : 'Cupom não pode ser aplicado para mais de 01 equipamento'}
                          </p>
                        </div>
                      ) : (
                        <div className="ticketDiv">
                          <Icons name="ticket" size="100%" color="#CFCFCF" />

                          <div className="ticketInfos">
                            <p>
                              <b>Código: </b> {ticket.codigo}
                            </p>
                            <p>
                              <b>Desconto: </b>{' '}
                              {ticket.tipo_desconto === 1
                                ? Mask.money.value(ticket.valor_desconto)
                                : `${ticket.valor_desconto} %`}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="rightSide"
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
          }}>
          <div>
            <div className="controlPlans">
              <div className="plansHeaderFixed" style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
                <p className={isMobile ? 'p__one_phone' : 'p__one'}>Coberturas selecionadas</p>
                <p className="p__two">LMI</p>
                <p className="p__tree">Custo do seguro</p>
              </div>
              {prevData.cobertura?.coberturas &&
                prevData.cobertura.coberturas.map((item) => {
                  /*  return (
                    <div key={item.label} className={`plan nowUSee`}>
                      <div
                        className="checkPlan"
                        style={{
                          background: !!corPrimaria ? corPrimaria : '#023a86',
                          borderColor: !!corPrimaria ? corPrimaria : '#023a86',
                        }}>
                        <span className="radioToCheck"></span>
                      </div>

                      <div className="planContainer">
                        <div className="planHeader">
                          <p>{item.nome}</p>
                        </div>

                        <div id={item.label} className="planDescription">
                          <p>{item.franquia}</p>
                        </div>
                      </div>
                    </div>
                  ); */
                  if (item.label !== 'assistencia_ciclomotor') {
                    const percentage = prevData.cobertura.porcentagens[item.label];
                    const rcm = item.label === 'resp_civil_materiais';
                    let addValue;

                    if (!!rcm && (+Mask.money.raw(prevData.segurado_bicicleta.valor) * percentage) / 100 > 250000) {
                      addValue = 250000;
                    } else {
                      addValue = percentage
                        ? (+Mask.money.raw(prevData.segurado_bicicleta.valor) * percentage) / 100
                        : Mask.money.raw(prevData.segurado_bicicleta.valor);
                    }

                    return (
                      <div key={item.id} className="planItemControl">
                        <div className={isMobile ? 'planItemName_phone' : 'planItemName'}>
                          <p>{item.nome.length > 8 && isMobile ? item.nome.substring(0, 8) + '...' : item.nome}</p>
                        </div>

                        <div className="planItemContractValue">
                          <p>{Mask.money.value(addValue * (prevData.segurado_bicicleta.lmi_contratado / 100))}</p>
                        </div>

                        <div className="planItemFinalValue">
                          {ticket?.codigo && ticket.tipo_desconto === 0 ? (
                            <div>
                              <span>{Mask.money.value(parseFloat(comTaxa[item.label]).toFixed(2))}</span>
                              <p>
                                {Mask.money.value(
                                  parseFloat(comTaxa[item.label] - (comTaxa[item.label] * ticket.valor_desconto) / 100).toFixed(
                                    2,
                                  ),
                                )}
                              </p>
                            </div>
                          ) : (
                            <p>{Mask.money.value(parseFloat(comTaxa ? comTaxa[item.label] : 0).toFixed(2))}</p>
                          )}
                        </div>
                      </div>
                    );
                  }
                })}

              <div className="totalPlansDiv">
                <p>Total</p>
                <span>{Mask.money.value(parseFloat(total - totalAssistencia).toFixed(2))}</span>
              </div>
              {ticket?.codigo && (
                <div>
                  <div className="totalPlansTicket">
                    <p>Cupom: {ticket.codigo}</p>
                    <span>
                      {ticket.tipo_desconto === 1 ? Mask.money.value(ticket.valor_desconto) : `${ticket.valor_desconto} %`}
                    </span>
                  </div>

                  <div className="totalPlansTicketWithCalc">
                    <span>
                      {Mask.money.value(
                        ticket.tipo_desconto === 1
                          ? total - totalAssistencia - ticket.valor_desconto
                          : total - totalAssistencia - ((total - totalAssistencia) * ticket.valor_desconto) / 100,
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {prevData.cobertura?.coberturas &&
            prevData.cobertura.coberturas.find(({label}) => label === 'assistencia_ciclomotor') && (
              <div style={{paddingTop: '10px', paddingBottom: '330px'}}>
                <div className="controlPlans">
                  <div className="plansHeaderFixed">
                    <p className={isMobile ? 'p__one_phone' : 'p__one'}>Serviços Emergenciais</p>
                    <p className="p__tree">Custo do seguro</p>
                  </div>
                  {prevData.cobertura?.coberturas &&
                    prevData.cobertura.coberturas.map((item) => {
                      if (item.label === 'assistencia_ciclomotor') {
                        const percentage = prevData.cobertura.porcentagens[item.label];
                        const rcm = item.label === 'resp_civil_materiais';
                        let addValue;

                        if (!!rcm && (+Mask.money.raw(prevData.segurado_bicicleta.valor) * percentage) / 100 > 250000) {
                          addValue = 250000;
                        } else {
                          addValue = percentage
                            ? (+Mask.money.raw(prevData.segurado_bicicleta.valor) * percentage) / 100
                            : Mask.money.raw(prevData.segurado_bicicleta.valor);
                        }

                        return (
                          <div key={item.id} className="planItemControl">
                            <div className={isMobile ? 'planItemName_phone' : 'planItemName'} style={{width: '100%'}}>
                              <p>{item.nome.length > 25 && isMobile ? item.nome.substring(0, 25) + '...' : item.nome}</p>
                            </div>
                            <div className="planItemFinalValue">
                              {ticket?.codigo && ticket.tipo_desconto === 0 ? (
                                <div>
                                  <span>{Mask.money.value(parseFloat(comTaxa[item.label]).toFixed(2))}</span>
                                  <p>
                                    {Mask.money.value(
                                      parseFloat(
                                        comTaxa[item.label] - (comTaxa[item.label] * ticket.valor_desconto) / 100,
                                      ).toFixed(2),
                                    )}
                                  </p>
                                </div>
                              ) : (
                                <p>{Mask.money.value(parseFloat(comTaxa ? comTaxa[item.label] : 0).toFixed(2))}</p>
                              )}
                            </div>
                          </div>
                        );
                      }
                    })}

                  <div className="totalPlansDiv">
                    <p>Total Cobertura + Assistência</p>
                    <span>{Mask.money.value(parseFloat(total).toFixed(2))}</span>
                  </div>
                  {ticket?.codigo && (
                    <div>
                      <div className="totalPlansTicket">
                        <p>Cupom: {ticket.codigo}</p>
                        <span>
                          {ticket.tipo_desconto === 1 ? Mask.money.value(ticket.valor_desconto) : `${ticket.valor_desconto} %`}
                        </span>
                      </div>

                      <div className="totalPlansTicketWithCalc">
                        <span>
                          {Mask.money.value(
                            ticket.tipo_desconto === 1
                              ? total - ticket.valor_desconto
                              : total - (total * ticket.valor_desconto) / 100,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </form>
  );
};

export default React.memo(ResumoCobertura, areEqual());
export const ref = React.createRef();
